
































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class FormatMultipleVals extends Vue {
  get codeSnippet1 () {
    return `name = 'Alex'
welcome_message = 'Welcome, %s' % name
print(welcome_message)`
  }

  get codeSnippet2 () {
    return `name = 'Alex'
birthday = 'January 10th'
birthday_message = 'My name is %s and I was born on %s' % (name, birthday)
print(birthday_message)`
  }

  get codeSnippet3 () {
    return `name = 'Alex'
welcome_message = 'Welcome, {0}'.format(name)
print(welcome_message)
`
  }

  get codeSnippet4 () {
    return `name = 'Alex'
birthday = 'January 10th'
birthday_message = 'My name is {0} and I was born on {1}'.format(name, birthday)
print(birthday_message)`
  }
}
